import { friendlyTime } from '../../utils/friendly_time';
import './ChannelApp.css';

// The channel app's embed block (backend sdk_apps/channel.py, view `recent`):
// the newest root messages, read-only, as GET /api/entities/{id}/embed carries
// them. Rendered for nobody in particular, on other sites and in the embed
// page, so it draws only what it is given: names and text, no pictures to
// fetch, no actions. `now` is for tests; the page passes nothing.
export function ChannelEmbed({ data, now = Date.now() }) {
    const messages = data?.messages || [];
    if (messages.length === 0) {
        return <div className="channel-embed"><span className="channel-embed__meta">No messages yet.</span></div>;
    }
    return (
        <div className="channel-embed">
            {data.has_more && <span className="channel-embed__meta">Earlier messages are not shown.</span>}
            {messages.map(m => (
                <div className="channel-embed__row" key={m.message_id}>
                    <span className="channel-embed__sender">{m.sender_name || 'Someone'}</span>
                    <span className="channel-embed__meta">{friendlyTime(m.timestamp, now)}</span>
                    <div className="channel-embed__text">{m.content}</div>
                    {m.reply_count > 0 && (
                        <span className="channel-embed__replies">{m.reply_count} {m.reply_count === 1 ? 'reply' : 'replies'}</span>
                    )}
                </div>
            ))}
        </div>
    );
}

export default ChannelEmbed;
